
import { useState } from 'react';

const useModal = () => {
  
  const [isRecordOfflineModalShowing, setIsRecordOfflineModalShowing] = useState(false);
  const [isVerifyReconciledPaymentModalShowing, setIsVerifyReconciledPaymentModalShowing] = useState(false);
  const [campaignForVerification, setCampaignForVerification] = useState(undefined);
  const [campaignForVerificationPaymentDate, setCampaignForVerificationPaymentDate] = useState(undefined);
  const [campaignForVerificationPaymentAmount, setCampaignForVerificationPaymentAmount] = useState(undefined);
  const [campaignForVerificationTransactionProof, setCampaignForVerificationTransactionProof] = useState(undefined);
  
  

  function recordOfflineModalToggle() {
    setIsRecordOfflineModalShowing(!isRecordOfflineModalShowing);
  }

  function verifyReconciledPaymentModalToggle(campaignId, date, amount, transactionProof) {
    setIsVerifyReconciledPaymentModalShowing(!isVerifyReconciledPaymentModalShowing);
    setCampaignForVerification(campaignId);
    setCampaignForVerificationPaymentDate(date);
    setCampaignForVerificationPaymentAmount(amount);
    setCampaignForVerificationTransactionProof(transactionProof);
  }

  return {
    isRecordOfflineModalShowing,
    recordOfflineModalToggle,
    isVerifyReconciledPaymentModalShowing,
    verifyReconciledPaymentModalToggle,
    campaignForVerification,
    campaignForVerificationPaymentDate,
    campaignForVerificationPaymentAmount,
    campaignForVerificationTransactionProof
  }
};

export default useModal;


// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/useModel.js